import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const renameCampaignRequestSchema = z.object({
  name: z.string().trim().min(1),
});

export type RenameCampaignRequest = z.infer<typeof renameCampaignRequestSchema>;

export async function RenameCampaign(
  campaignId: string,
  request: RenameCampaignRequest,
  signal?: AbortSignal,
): Promise<void> {
  const parsedRequest = renameCampaignRequestSchema.parse(request);
  await socialApiClient.patch(`campaigns/${campaignId}/name`, {
    json: parsedRequest,
    signal,
  });
}
